import React, { useState } from 'react';
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';


import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import type { IssueCreate } from '../api-client/models/IssueCreate';
import { UrgencyLevel } from '../api-client/models/UrgencyLevel';
import { AdminService } from '../api-client/services/AdminService';
import { useLogger } from './Logger';
import { useIMessage, useINotify, Severity } from './iNotify';
import BugReportIcon from '@mui/icons-material/BugReport';
import { useIntl } from 'react-intl';


import CheckSyncComponent from '../components/CheckSyncComponent';
import SyncComponent from '../components/SyncComponent';
const initialIssue: IssueCreate = {
  title: '',
  body: '',
  is_bug: false,
  level: UrgencyLevel.LOW,
};

const SyncDialogComponent: React.FC = () => {
  const commit = import.meta.env.GIT_COMMIT;
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [issue, setIssue] = useState<IssueCreate>(initialIssue);
  const logger = useLogger();
  const imessage = useIMessage();
  const inotify = useINotify();
  const intl = useIntl();
  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
  };



  return (
    <>
      {/* <Button variant="outlined" onClick={handleOpen} startIcon={<BugReportIcon />}>
        Issue
      </Button> */}
      <Tooltip title={intl.formatMessage({ id: '__start_sync__' })}>
        <Avatar
          variant="rounded"
          sx={{
            ...theme.typography.commonAvatar,
            ...theme.typography.mediumAvatar,
            transition: 'all .2s ease-in-out',
            color: theme.vars.palette.primary.dark,
            background: theme.vars.palette.primary.light,
            '&:hover': {
              color: theme.vars.palette.primary.light,
              background: theme.vars.palette.primary.main
            },

            ...theme.applyStyles('dark', {
              color: theme.vars.palette.primary.dark,
              background: theme.vars.palette.dark.main,
              '&:hover': {
                color: theme.vars.palette.primary.light,
                background: theme.vars.palette.primary.main
              }
            })
          }}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleOpen}
        >
          {/* {open ? <IconArrowsMinimize /> : <IconArrowsMaximize />} */}
          {/* <BugReportIcon /> */}
          <CheckSyncComponent />
        </Avatar>
      </Tooltip>



      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{intl.formatMessage({ id: '__start_sync__' })}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
            <SyncComponent onStart={() => { setSubmitting(true); console.log('Sync started'); }} />
          </Box>
        </DialogContent>

        <DialogActions>
          <Button
            onClick={handleClose}
          //disabled={submitting}
          >
            Cancel
          </Button>
          <Button
            onClick={handleClose}
            variant="contained"
            disabled={!submitting}
            //startIcon={submitting ? <CircularProgress size={18} /> : undefined}
          >
            {intl.formatMessage({ id: '__run_in_background__' })}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SyncDialogComponent;
